import React from "react";
import { Outlet } from "react-router-dom";
import { useIsMobile } from "../hooks/use-mobile";
import { RadixSidebarDemo } from "../pages/Sidebar";

export default function DesktopSidebarLayout() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <Outlet />;
  }

  return (
    <RadixSidebarDemo>
      <Outlet />
    </RadixSidebarDemo>
  );
}

